module.exports = __webpack_public_path__ + "static/media/bg-side-imagine.6975ee15.jpg";